<template>
    <div :class="[
            'sustainability-page-accordion',
            { 'sustainability-page-accordion--opened': state }
        ]"
    >
        <div
            class="sustainability-page-accordion__header"
            @click="toggleItem"
        >
            <span
                v-if="title"
                class="sustainability-page-accordion__title"
                v-html="title"
            />
            <span
                v-if="indicator"
                class="sustainability-page-accordion__indicator"
                v-html="indicator"
            />
        </div>
        <transition
            @enter="animationEnter"
            @leave="animationLeave"
        >
            <div
                v-show="state || device === 'mobile'"
                class="sustainability-page-accordion__body"
            >
                <div class="sustainability-page-accordion__content">
                    <div
                        v-if="!!$slots.default"
                        class="sustainability-page-accordion__text"
                    >
                        <slot />
                    </div>
                    <div
                        v-if="image"
                        class="sustainability-page-accordion__image"
                    >
                        <img
                            :src="image"
                            :alt="title"
                        />
                        <span
                            v-if="imageIndicator"
                            class="sustainability-page-accordion__image-indicator"
                            v-html="imageIndicator"
                        ></span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Velocity from 'velocity-animate'
import { mixinDevice } from '@/utils/mixin'

export default {
    name: 'sustainability-page-accordion',
    mixins: [mixinDevice],
    props: {
        id: {
            type: String,
            required: true
        },
        title: String,
        indicator: String,
        image: String,
        imageIndicator: String
    },
    data () {
        return {
            state: false,
            duration: 500
        }
    },
    methods: {
        toggleItem () {
            this.state = !this.state
            this.$emit('toggle', this.state ? this.id : '')
        },

        animationEnter (el, done) {
            Velocity(el, 'slideDown', { duration: this.duration })
        },
        animationLeave (el, done) {
            Velocity(el, 'slideUp', { duration: this.duration })
        }
    }
}
</script>

<style lang="scss">
.sustainability-page-accordion {
    $parent: &;
    border-radius: 20px 20px 20px 0px;
    background: $token-colors-gray-10;
    position: relative;

    @include breakpoint(mobile) {
        display: flex;
        flex-direction: column;
        border-radius: 16px 16px 16px 0px;
    }

    &:hover {
        background: $token-colors-blue-10;
    }

    &--opened {
        #{$parent}__indicator {
            opacity: 0;
        }

        #{$parent}__content {
            opacity: 1;
        }
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 24px;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.12px;
        color: $token-colors-gray-60;
        padding: $token-spacers-s $token-spacers-m;
        position: relative;
        z-index: 1;
        cursor: pointer;

        @include breakpoint(mobile) {
            font-size: 20px;
            padding: $token-spacers-xs $token-spacers-2-xs $token-spacers-2-xs;
            pointer-events: none;
            cursor: default;
        }
    }

    &__title {
        padding-right: 348px;

        @include breakpoint(v-tablet) {
            padding-right: $token-spacers-xs;
        }
    }

    &__indicator {
        position: absolute;
        top: $token-spacers-s;
        right: $token-spacers-m;
        transition: opacity 0.5s;

        @include breakpoint(v-tablet) {
            position: relative;
            top: unset;
            right: unset;
        }

        @include breakpoint(mobile) {
            display: none;
        }
    }

    &__body {
        padding: 0 $token-spacers-m $token-spacers-s;
        margin-top: -60px;

        @include breakpoint(v-tablet) {
            margin-top: 0;
        }

        @include breakpoint(mobile) {
            flex: 1;
            padding: 0 $token-spacers-2-xs $token-spacers-2-xs;
        }
    }

    &__content {
        display: flex;
        justify-content: space-between;
        gap: $token-spacers-xs;
        transition: opacity 0.5s;
        opacity: 0;

        @include breakpoint(v-tablet) {
            flex-direction: column;
        }

        @include breakpoint(mobile) {
            height: 100%;
            opacity: 1;
        }
    }

    &__text {
        max-width: 690px;
        font-size: 18px;
        line-height: 150%;
        color: $token-colors-gray-60;
        margin-top: 60px;

        @include breakpoint(v-tablet) {
            max-width: 100%;
            margin-top: 0;
        }

        @include breakpoint(mobile) {
            font-size: 16px;
        }
    }

    &__image {
        max-width: 324px;
        display: flex;
        border-radius: 40px 0px 20px 0px;
        position: relative;
        overflow: hidden;

        @include breakpoint(v-tablet) {
            max-width: 460px;
        }

        @include breakpoint(mobile) {
            max-width: 100%;
            border-radius: 32px 0px 16px 0px;
        }

        img {
            width: 100%;
            height: auto;
            object-fit: cover;
        }
    }

    &__image-indicator {
        font-size: 40px;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.4px;
        color: $token-colors-white;
        position: absolute;
        right: $token-spacers-2-s;
        bottom: $token-spacers-xs;

        @include breakpoint(v-tablet) {
            font-size: 32px;
        }

        @include breakpoint(mobile) {
            font-size: 26px;
            right: unset;
            left: $token-spacers-2-xs;
        }
    }
}
</style>
